// Path: src\Components\MyContest\MyTournamentTab.jsx
import { React, useCallback, useEffect, useRef, useState } from "react";
import { useTranslation } from "react-i18next";
import { ReactComponent as CalendarIcon } from "../../assets/images/CalenderIcon.svg";
import { myTournamentList } from "../../api/tournament.api";
import moment from "moment";
import Countdown from 'react-countdown';

import { toastInfo } from '../../Utilities/toast'
import { useNavigate } from "react-router";
import ListLoader from "../Common/ListLoader";

const MyTournamentList = () => {
  const profile = JSON?.parse(localStorage.getItem("profile"));
  const [list, setList] = useState([]);
  const [currentPage, setCurrentPage] = useState(1);
  const [recordPerPage, setRecordPerPage] = useState(5);
  const [totalPages, setTotalPages] = useState(1);
  const [loading, setLoading] = useState(true)
  const navigate = useNavigate();
  const { t } = useTranslation();

  useEffect(() => {
    if (currentPage <= totalPages)
      loadMore()
  }, [currentPage])

  const loadMore = async () => {
    setLoading(true)
    fetchTournaments()
  }

  const observer = useRef();
  const lastPostElementRef = useCallback(
    async (node) => {
      if (loading) return;
      if (observer.current) observer.current.disconnect();

      observer.current = new IntersectionObserver((entries) => {
        if (entries[0].isIntersecting) {
          setCurrentPage((prevPage) => prevPage + 1);
        }
      });

      if (node) observer.current.observe(node);
    },
    [loading]
  );

  const fetchTournaments = async () => {
    try {
      let data = {
        filter: { user: profile?.user_id, game: localStorage.getItem('activeGameId') },
        pagination: {
          pageNo: currentPage,
          recordPerPage: recordPerPage,
          sortBy: 'startDate',
          sortDirection: "desc"
        }
      }

      const res = await myTournamentList(data);
      if (res?.success && res?.data?.length > 0) {
        setList([...list, ...res?.data])
        setTotalPages(res?.totalPages);
      }
      else {
        setList([]);
      }
    setLoading(false)

    } catch (error) {
      setLoading(false)

    }
  };

  const checkStatus = (status) => {
    if (status === "completed") {
      return (<div className="mycontest-container-box-status mycontest-container-box-status-completed">{status}</div>)
    }
    else if (status === "inProcess" || status === "review") {
      return (<div className="mycontest-container-box-status mycontest-container-box-status-inprocess">{status}</div>)
    }
    else if (status === "cancelled") {
      return (<div className="mycontest-container-box-status mycontest-container-box-status-cancelled">{status}</div>)
    }
    else {
      return (<div className="mycontest-container-box-status">{status}</div>)
    }
  }

  // const renderer = ({ hours, minutes, seconds, completed }) => {
  //   if (completed) {
  //     // Render a completed state
  //     return <></>;
  //   } else {
  //     // Render a countdown
  //     return <>- {t("my_tournament.starts_in")} {hours}:{minutes}:{seconds}</>;
  //   }
  // }

  const renderer = ({ days, hours, minutes, seconds, completed }) => {
    if (completed) {
        return <></>; 
    } else {
        const totalHours = parseInt(hours) + (parseInt(days) * 24); 
        return <>- {t("my_tournament.starts_in")} {totalHours.toString().padStart(2, '0')}:{minutes.toString().padStart(2, '0')}:{seconds.toString().padStart(2, '0')}</>;
    }
};


  return (
    <>{
      list && list?.length > 0 ? list?.map((item, index) => {
        return (
          <div onClick={() => navigate(`/tournament/details/${item?._id}`)} key={item._id}
            ref={list?.length === index + 1 ? lastPostElementRef : null}>
            {/* <div className="mycontest-timer mt-4">
              <>
                {item?.gameType?.name?.toLowerCase()} 
                {item?.status === "waiting" || item?.status === "started" && <Countdown date={new Date(moment(item?.contestsList?.date).format('YYYY/MM/DD') + " " + moment(item?.contestsList?.time).format('hh:mm a'))} renderer={renderer} /> }
              </>
            </div> */}
            
            <div className="mycontest-timer mt-4">
  <>
    {item?.gameType?.name?.toLowerCase()}{" "}
    {(item?.status === "waiting" || item?.status === "started") && (
      <Countdown date={new Date(moment(item?.contestsList?.date).format('YYYY/MM/DD hh:mm a'))} renderer={renderer} />
    )}
  </>
</div>
            <div className="mycontest-container-box">
              <div className="mycontest-container-heading-wrap">
                <div className="mycontest-container-box-title">
                {item?.title?.length > 25 ? (
                          <marquee>   {item?.title}</marquee>
                        ) : (
                          item?.title
                        )}
                  {/* {item?.title} */}
                </div>
                {checkStatus(item?.status)}
              </div>
              <hr className="hr-spacing"></hr>
              <div className="mycontest-container-details">
                <div className="mycontest-container-details-box-wrap">
                  <div className="mycontest-container-details-box-inner-wrap">
                    <span className="mycontest-customsvg">
                      <CalendarIcon />
                    </span>
                    <div className="mycontest-date-value">{moment(item?.startDate).format('DD/MM/YYYY')}</div>
                  </div>
                  <div className="mycontest-date-label tdate">{t("my_tournament.tournament_date")}</div>
                </div>

                <div className="mycontest-container-details-box-wrap">
                  <div className="mycontest-container-details-box-inner-wrap">
                    <div className="mycontest-date-value">{moment(item?.contestsList?.date).format('DD/MM/YYYY')}, {moment(item?.contestsList?.time).format('hh:mm a')}</div>
                  </div>
                  <div className="mycontest-date-label">{item?.contestsList?.title}</div>
                </div>
                <div className="mycontest-container-details-box-wrap">
                  <div className="mycontest-container-details-box-inner-wrap">
                    <div className="mycontest-date-value"> 
                       {item?.shortCode} 
                       </div>
                  </div>
                  <div className="mycontest-date-label">{t("my_tournament.id")}</div>
                </div>
              </div>

              <div className="mycontest-container-details-roomidpass mt-2">
                <div className="mycontest-container-details-roomidpass-innerwrap">
                  <div className="mycontest-container-details-roomidpass-value" onClick={() => {
                    navigator.clipboard.writeText(
                      item?.contestsList?.roomId
                    );
                    toastInfo(t("my_tournament.room_id_copied"))
                  }}>
                    {item?.contestsList?.roomId || "-"}
                  </div>

                  <div className="mycontest-container-details-roomidpass-label mycontest-container-details-roomidpass-label-1">
                    {t("my_tournament.room_id2")}
                  </div>
                </div>
                <div className="mycontest-container-details-roomidpass-innerwrap">
                  <div className="mycontest-container-details-roomidpass-value d-flex justify-content-end" onClick={() => {
                    navigator.clipboard.writeText(
                      item?.contestsList?.roomPassword
                    );
                    toastInfo(t("my_tournament.room_password_copied"))
                  }}>
                    {item?.contestsList?.roomPassword || "-"}
                  </div>

                  <div className="contest-room-id-pass-flex">

                    <div className="mycontest-container-details-roomidpass-label mycontest-container-details-roomidpass-label-1">
                      {t("my_tournament.room_password")}
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        )
      }) :!loading&& <> <div className='no-record-found-center-my-contestlist'><span className="text-center">{t('common.no_data_found')}</span></div></>
    }
        {loading && <div className='w-100 d-flex justify-content-center no-record-found-center'> <ListLoader /></div>}

    </>
  );
}
export default MyTournamentList;
